import React from "react";
import { SocketContext } from "./SocketProvider.context";
import { IWhatsAppActivity } from "../../redux/activity/activity.types";
import {
  IChatbotSocketResponse,
  IWhatsappSocketMessgae,
} from "./SocketProvider.types";

export function useSocketContext() {
  const context = React.useContext(SocketContext);

  if (!context) {
    throw new Error("SocketContext: Context must be used inside AuthProvider");
  }

  return context;
}

export interface INewWhatsappMessage {
  conversation: IWhatsappSocketMessgae;
  status: "RECEIVED";
}

export const useWhatsappMessageReceivedSocket =
  (): IChatbotSocketResponse | null => {
    const { socket, playNotificationSound } = useSocketContext();

    const [socketResponse, setSocketResponse] =
      React.useState<IChatbotSocketResponse | null>(null);

    React.useEffect(() => {
      if (!socket) return;
      socket.on("MESSAGE_RECEIVED", (data: IChatbotSocketResponse) => {
        console.log("MESSAGE_RECEIVED ====>", data);
        if (data.conversation.status === "RECEIVED") {
          playNotificationSound();
          setSocketResponse({
            conversation: data.conversation,
            status: "MESSAGE_RECEIVED",
          });
        }
      });

      socket.on("SEND_MESSAGE", (data: IChatbotSocketResponse) => {
        console.log("MESSAGE_SENT ====>", data);
        setSocketResponse({
          conversation: data.conversation,
          status: "MESSAGE_SENT",
        });
      });

      socket.on("MESSAGE_STATUS_RECEIVED", (data: IChatbotSocketResponse) => {
        console.log("MESSAGE_STATUS_RECEIVED ====>", data);
        setSocketResponse({
          conversation: data.conversation,
          status: "MESSAGE_STATUS_RECEIVED",
        });
      });
    }, [socket]);

    return socketResponse;
  };

// EX_MESSAGE_SEEN
// INITIATE
// EX_MESSAGE_SENT
// EX_MESSAGE_DELIVERED
// EX_RESTRICTED_BY_META
// EX_INCAPABLE_RECIPIENT
// EX_MARKETING_MESSAGE_EXPERIMENT_ERROR
// EX_SYSTEM_ERROR
// EX_TEMPLATE_PARAM_ERROR
// RECEIVED
// READ
// EX_RATE_LIMIT_HIT
// EX_INVALID_REQUEST
// SERVICE_OFF
// EX_MEDIA_UPLOAD_ERROR
// EX_UNKNOWN_ERROR
// UNDEFINED
// SENT
// BLOCKED_MARKETING
// DELIVERED
// INVALID_NUMBER
// FAILED
// SESSION_EXPIRED
// MEDIA_UPLOAD_FAILED
// ACCOUNT_LOCKED
// CLICKED
